//Global Style
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@mui/material/styles";
import { AnimatePresence } from "framer-motion";
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Copyright from "./components/Copyright";
import Footer from "./components/Footer";
import GlobalStyle from "./components/GlobalStyle";
import TopNav from "./components/TopNav";
import NotFound from "./pages/404";
import AGB from "./pages/AGB";
import AvailableJobs from "./pages/AvailableJobs";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import Kataloge from "./pages/Kataloge";
import PreislisteÜberblick from "./pages/PreislisteÜberblick";
import Prices from "./pages/Prices";
import Startpage from "./pages/Startpage";
import TeamBüro from "./pages/TeamBüro";
import Veranstaltung from "./pages/Veranstaltung";
import Verleihung from "./pages/Verleihung";
import Zweigstelle from "./pages/Zweigstelle";

export const PUBLIC_CND_BASEURL = "";

function App() {
	const location = useLocation();
	const theme = createTheme({
		palette: {
			primary: {
				main: "#f00",
			},
			secondary: {
				main: "#fff",
			},
			error: {
				main: "#c62828",
			},
			background: {
				default: "#f5f5f5",
			},
		},
		typography: {
			fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
			h1: {
				fontWeight: 700,
			},
			h2: {
				fontWeight: 600,
			},
			h5: {
				fontWeight: 500,
			},
			h6: {
				fontWeight: 600,
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					root: {
						borderRadius: 0,
						textTransform: "none",
						fontWeight: 600,
						"&:hover": {
							color: "#fff",
						},
					},
				},
			},
			MuiPaper: {
				styleOverrides: {
					root: {
						borderRadius: 0,
					},
				},
			},
			MuiTypography: {
				styleOverrides: {
					root: {
						padding: 0,
					},
				},
			},
		},
	});

	return (
		<div
			className="App"
			style={{ minHeight: "100dvh", display: "flex", flexDirection: "column" }}
		>
			<GlobalStyle />

			{location.pathname !== "/veranstaltung/mottoparty" && <Copyright />}
			<ThemeProvider theme={theme}>
				{location.pathname !== "/" && <TopNav position={"relative"} />}
				<div
					style={{
						flex: "1 1 0%",
						display: "flex",
						flexDirection: "column",
						width: "100%",
						justifyContent: "space-between",
					}}
				>
					<AnimatePresence mode="wait">
						<Routes location={location}>
							<Route path="/" exact element={<Startpage />} />
							<Route path="/Büro" exact element={<TeamBüro />} />
							<Route path="/zweigstelle/:zweig" element={<Zweigstelle />} />
							<Route path="/jobs" element={<AvailableJobs />} />

							<Route
								path="/team/:team"
								element={<Verleihung key={location.pathname} />}
							/>
							<Route
								path="/verleih/:verleihung"
								element={<Verleihung key={location.pathname} />}
							/>
							<Route
								path="/eventmodule/vr"
								exact
								element={<Verleihung key={location.pathname} />}
							/>

							<Route
								path="/eventmodule/:type"
								element={<Veranstaltung key={location.pathname} />}
							/>
							<Route
								path="/veranstaltung/:type"
								element={<Veranstaltung key={location.pathname} />}
							/>
							<Route
								path="/preisliste/:type"
								element={<Veranstaltung key={location.pathname} />}
							/>

							<Route path="/preisliste" element={<PreislisteÜberblick />} />
							<Route path="/kataloge" element={<Kataloge />} />
							<Route path="/prices/:url" element={<Prices />} />
							<Route path="/impressum" element={<Impressum />} />
							<Route path="/datenschutz" element={<Datenschutz />} />
							<Route path="/agb" element={<AGB />} />

							<Route path="*" element={<NotFound />} />
						</Routes>
						<Footer />
					</AnimatePresence>
				</div>
			</ThemeProvider>
		</div>
	);
}

export default App;
